angular.module('iqxCore')
.controller('SendMessageDialogCtrl', function ($scope, sendMessageDialogSvc, getData) {
  $scope.theRecord=getData.theRecord
  $scope.theLinks=getData.theLinks
  $scope.formError=''
  $scope.isEditing=true
  $scope.isSubmitted=false
  $scope.send=function() {
    $scope.isSubmitted=true  // Show the validation errors
    if ($scope.theForm.$valid) {
      sendMessageDialogSvc.saveMessage($scope,$scope.theRecord.ptype,$scope.theRecord.ptitle,$scope.theRecord.pdescription,$scope.theLinks)
      .then(function(){
        $scope.$close()
        }) 
      }
    }
})
